import TableBase from 'components/Table/TableBase'
import { numberWithCommas } from 'utils'
import { Link } from 'react-router-dom'

const HistoryTable = ({ data, setParams, params }) => {
  const columns = [
    {
      title: 'Tài khoản',
      dataIndex: 'customer',
      render: (value) => value?.id,
    },
    {
      title: 'Ký quỹ hiện tại',
      dataIndex: 'escrow_before',
      render: (value) => (
         <div>
          {value >= 0 && (
            <div className="text-right text-green text-bold">{numberWithCommas(value)}</div>
          )}
          {value < 0 && (
            <div className="text-right text-red text-bold">{numberWithCommas(value)}</div>
          )}
        </div>
      ),
    },
    {
      title: 'Số dư',
      dataIndex: 'balance',
      render: (value) => (
         <div>
          {value >= 0 && (
            <div className="text-right text-green text-bold">{numberWithCommas(value)}</div>
          )}
          {value < 0 && (
            <div className="text-right text-red text-bold">{numberWithCommas(value)}</div>
          )}
        </div>
      ),
    },
    {
      title: 'Tổng đơn',
      dataIndex: 'count_order',
      render: (value) => value,
    },
    {
      title: 'Thời gian đối soát',
      dataIndex: 'created_at',
      render: (value) => value,
    },
    {
      title: 'Trạng thái thanh toán',
      dataIndex: 'is_escrow_string',
      render: (value) => value,
    },
    {
      title: 'Thao tác',
      render: (record) => (
        <div>
          {record?.id && (
            <Link to={`/bao-cao-tai-chinh?reconcilation_id=${record?.id}`}>Chi tiết</Link>
          )}
        </div>
      ),
    },
  ]

  return (
    <TableBase
      columns={columns}
      style={{ minHeight: '300px' }}
      dataSource={data?.reconcilations}
      pagination={{
        current: data?.meta?.current_page,
        pageSize: data?.meta?.per_page,
        total: data?.meta?.total,
        showSizeChanger: true,
        onChange: (page, pageSize) => {
          if (pageSize !== data?.meta?.per_page) {
            page = 1
          }
          window.scrollTo({ top: 0, behavior: 'smooth' })
          setParams((prev) => ({
            ...prev,
            page: page,
            per_page: pageSize,
          }))
        },
        showTotal: (total) => `Tổng ${total}`,
      }}
      scroll={{ x: 1000 }}
      rowKey={(row) => row?.id}
    />
  )
}

export default HistoryTable
